<!-- 录播 -->
<template>
  <div class="video-record-page">
    <common-title :titleName="headerTitle" :bcColor="'#FEFEFF'" @goBack="goBack" :zIndex="1000">
      <img
        class="feedback-icon"
        @click="feedbackVisible = true"
        slot="btnSty"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/feedback-icon.png"
      />
      <img
        class="evaluate-icon"
        @click="evaluateVisible = true"
        slot="btnSty"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/zan1.png"
      />
    </common-title>
    <FeedBack
      @feedbackClose="feedbackClose"
      :visible="feedbackVisible"
      :videoName="headerTitle"
      :productName="productName"
      :errorMsg="playerErrorMsg"
    />
    <Evaluate
      ref="evaluate"
      v-if="routeParams"
      :visible="evaluateVisible"
      @evaluateClose="evaluateClose"
      :resourceId="routeParams.resourceId"
      :resourceType="2"
      :resourceName="headerTitle"
      :productId='productId'
    />
    <div class="empty"></div>
    <div class="video-record">
      <div id="player"></div>
      <div class="jurisdiction" v-show="jurisdiction">没有此课程权限</div>
      <div class="next-video" v-if="videoEndTool">
        <template v-if="nextVideoInfo.id">
          <span>本节课程已学完</span>
          <span class="video-title">下一节：{{ nextVideoInfo && nextVideoInfo.name }}</span>
          <div class="tool-btn">
            <div class="replay-btn" @click="replay">重新播放</div>
            <div class="next-btn" @click="nextVideo">下一节</div>
          </div>
        </template>
        <template v-else>
          <span>本节课程已学完</span>
          <div class="tool-btn">
            <div class="replay-btn" @click="replay">重新播放</div>
          </div>
        </template>
      </div>
      <OpenApp ref="openApp" />
    </div>
    <div class="course-tree">
      <!-- 测试计时器{{reportCount}} -->
      <div class="tree-title">课表目录</div>
      <div class="tree-div">
        <CourseTree v-if="learnData" :treeNodeInit="treeData" :learnData="learnData"
          :learningProgressList="learningProgressList" treeType="learnGuideTree" :catalogInfo="$route.params" />
      </div>
    </div>
    <CommonLoading :loading="loading" />
    <Foot />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import loadJS from 'load-js';
import moment from 'moment';
import { RECORD_SITE_ID } from '@/utils/common';
import OpenApp from '@/pages/live/components/openApp.vue';
import CommonTitle from '@/components/header/CommonTitle.vue';
import { sendUploadStudyProgress, getBJYToken } from '@/api/live';
import { reqCourseTree, reqGetNodeResource, reqGetCheckCourse, reqQualities } from '@/api/learn';
import { reqCourseDetail, reqNewLearnProgress } from '@/api/learningGuidePage';
import { reqClassNameType } from '@/api/courseDetail';
import CommonLoading from '@/components/commonComponents/CommonLoading.vue';
import CourseTree from '@/components/course/CourseTree.vue';
import Foot from '@/components/foot/privacy.vue';
import { gioPlatform } from '@/utils/tools';
import { QUALITIES } from '@/utils/types';
import FeedBack from './components/feedback.vue';
import Evaluate from './components/evaluate.vue';
import { judgmentPlatform } from '@/utils/tools';

let flag = false;
let startViewTime = 0;

export default {
  data() {
    return {
      routeParams: null,
      isCC: null, // 是否是CC播放器
      player: null, // 播放器对象
      timer: null, // 300秒定时器
      count: 0,
      lastLearnDuration: 0, // 上次学习进度
      recordVideoId: 0,
      recordId: 0,
      isFirstEnter: true,
      treeData: [],
      videoList: [],
      nextVideoInfo: {},
      videoEndTool: false,
      headerTitle: '视频播放',
      loading: true,
      learnData: null,
      reportCount: 0,
      BJYPlayer: null, // 百家云播放器
      BJYDuration: 0, // 当前视频总时长
      seeklock: true,
      jurisdiction: false, // 视频权限
      canPlay: true,
      feedbackVisible: false, // 反馈弹窗标识
      productName: '', // 产品名称
      playerErrorMsg: '',
      learningProgressList: [],
      defaultQualitis: [],
      evaluateVisible: false,
    };
  },

  components: {
    OpenApp,
    CommonTitle,
    CommonLoading,
    CourseTree,
    Foot,
    FeedBack,
    Evaluate,
  },

  computed: {
    ...mapState(['userInfo']),
  },

  watch: {
    // 监听相同路由下参数变化的时候，从而实现异步刷新
    $route() {
      if (this.player && this.player.getVideoState() === 'play' && this.isCC) {
        this.reportPlayerTime(2);
      } else if (Number(this.routeParams.type) === 2) {
        this.reportPlayerTime(2);
      }
      // Object.assign(this.$data, this.$options.data());
      this.initData();
    },
    evaluateVisible(data) {
      if (data) {
        if (this.isCC) {
          this.player?.pause();
        } else {
          this.BJYPlayer?.pause();
        }
      } else if (this.isCC) {
        this.player?.play();
      } else {
        this.BJYPlayer?.play();
      }
    },
  },
  created() {},
  mounted() {
    if (!this.$root.$data.isApp) {
      window.addEventListener('beforeunload', this.uploadPageWxpose);
    }
    this.initData();
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        if (this.player) {
          this.player.pause();
        }
        if (this.BJYPlayer) {
          this.BJYPlayer.pause();
        }
      }
    });
  },
  beforeDestroy() {
    if (!this.$root.$data.isApp) {
      this.uploadPageWxpose();
    }
  },
  methods: {
    feedbackClose() {
      this.feedbackVisible = false;
    },
    initData() {
      // 初始化数据
      this.loading = true;
      this.isFirstEnter = true;
      this.lastLearnDuration = 0;
      this.routeParams = this.$route.params;
      this.isCC = Number(this.$route.params.type) === 1; // 1 CC 2 百家云
      this.BJYDuration = this.$route.params.duration; // 百家云视频总时长
      this.destroyPlay();
      window.clearInterval(this.timer);
      this.getDefaultQualities(); // 获取默认清晰度
      this.init();
    },

    async init() {
      await this.getCourseTreeInfo(); // 获取课程详情
      this.gioReName();
      if (!this.canPlay) return;
      const result = await this.checkCourse(); // 播放权限
      if (!result) {
        return;
      }
      await this.getLearnDuration(); // 获取上次播放记录
      this.getNodeResource(); // 遍历tree选中当前节点
      // CC与百家云加载不同的sdk
      if (this.isCC) {
        // CC
        loadJS([
          {
            async: false,
            url: 'https://p.bokecc.com/player?siteid=096E928BC2A97B87&newversion=true',
          },
        ]).then(() => {
          this.setPlayerCallBack();
        });
      } else {
        // 百家云
        loadJS([
          {
            async: false,
            url: 'https://www.baijiayun.com/bplayer/latest/bplayer.js',
          },
          {
            async: false,
            url: 'https://www.baijiayun.com/bplayer/latest/dep/ffplayer.js',
          },
        ]).then(() => {
          // 百家云
          this.initBJYPlayer();
        });
      }
    },

    // 字典获取默认清晰度
    async getDefaultQualities() {
      const res = await reqQualities('VOD_CLARITY_CONTROL');
      this.defaultQualitis = res.data;
    },

    // 获取对应视频清晰度的值；
    handleQualities(type) {
      if (type === 'cc') {
        return this.defaultQualitis.filter((item) => item.code === 'CC_VOD_CLARITY')[0].value;
      }
      return this.defaultQualitis.filter((item) => item.code === 'BJY_VOD_CLARITY')[0].value;
    },

    // 设置cc和百家云的视频清晰度
    setVideoQualities(type, qualitieList) {
      const isCC = type === 'cc';
      const videoQUALITIES = isCC ? QUALITIES[0] : QUALITIES[1];
      const qualities = videoQUALITIES[this.handleQualities(type)]
        ? videoQUALITIES[this.handleQualities(type)]
        : qualitieList[0]?.label;
      // const qualities = '清晰';
      // 判断视频是否有后台设置的清晰度
      const isHaveQualities = isCC
        ? qualitieList.find((item) => item.label === qualities)
        : qualitieList.find((item) => item.name === qualities); // 接口中的清晰度是否在列表中存在
      // eslint-disable-next-line no-nested-ternary
      const resultQualities = isHaveQualities
        ? isCC
          ? isHaveQualities?.value
          : isHaveQualities?.type
        : isCC
        ? qualitieList[0]?.value
        : qualitieList[qualitieList.length - 1]?.type; // 存在取接口中的清晰度，否则设置列表中最高的清晰度
      if (isCC) {
        this.player.setQuality(resultQualities);
      } else {
        this.BJYPlayer.switchQuality({ quality: resultQualities });
      }
    },
    // 处理视屏播放器的清晰度
    handleVideoQualities(type) {
      const isCC = type === 'cc';
      const qualitieList = isCC ? this.player.getQualities() : this.BJYPlayer.qualityList;
      const localStorageQualityMsgStr = localStorage.getItem('userQuality'); // 获取用户手动设置清晰度后的缓存数据
      const localStorageQualityMsgObj = localStorageQualityMsgStr
        ? JSON.parse(localStorageQualityMsgStr)
        : undefined;
      if (
        localStorageQualityMsgStr &&
        ((localStorageQualityMsgObj?.type === 'cc' && isCC) ||
          (localStorageQualityMsgObj?.type === 'bjy' && !isCC))
      ) {
        // 有缓存并且命中对应类型的视频,设置缓存中的清晰度，没有则设置接口里的视屏清晰度
        if (localStorageQualityMsgObj.type === 'cc' && isCC) {
          if (!qualitieList.find((item) => item.value === localStorageQualityMsgObj?.NewQuality)) {
            // 如果列表中没有缓存数据中的清晰度，则设置接口里的视屏清晰度
            this.setVideoQualities(type, qualitieList);
            return;
          }
          this.player.setQuality(localStorageQualityMsgObj?.NewQuality); // 设置cc视屏清晰度;
        }
        if (localStorageQualityMsgObj.type === 'bjy' && !isCC) {
          if (!qualitieList.find((item) => item.type === localStorageQualityMsgObj?.NewQuality)) {
            // 如果列表中没有缓存数据中的清晰度，则设置接口里的视屏清晰度
            this.setVideoQualities(type, qualitieList);
            return;
          }
          this.BJYPlayer.switchQuality({ quality: localStorageQualityMsgObj?.NewQuality }); // 设置百家云视屏清晰度;
        }
        return; // 不往下执行
      }
      this.setVideoQualities(type, qualitieList);
    },

    // 自定义监听cc、百家云清晰度切换事件
    listenerToQualityChange(type) {
      const ClassName = type === 'cc' ? '.ccH5hdul li' : '.bplayer-option-item.quality';
      document.querySelectorAll(ClassName).forEach((item) => {
        item.addEventListener(
          'click',
          (e) => {
            if (e.isTrusted) {
              this.setUserChangeQuality(type);
            }
          },
          false,
        );
      });
    },

    // 设置用户手动切换清晰度的标识
    setUserChangeQuality(type) {
      // 设置定时器是因为需要等待播放器切换完清晰度后，才能获取最新的清晰度；
      setTimeout(() => {
        const NewQuality = type === 'cc' ? this.player.getCurrDf() : this.BJYPlayer.quality;
        localStorage.setItem('userQuality', JSON.stringify({ type, NewQuality })); // 缓存清晰度
      }, 1000);
    },
    // 百家云视频初始化
    async initBJYPlayer() {
      const { vid, resourceId, openCourseId } = this.routeParams;
      const res = await getBJYToken({
        vid,
        id: resourceId,
        userProductId: openCourseId,
      });
      if (res.code === -1) {
        this.jurisdiction = true;
        return;
      }
      flag = false;
      startViewTime = moment().unix();
      this.jurisdiction = false;
      const { token } = res.data;
      const seekFn = this.debounce(this.onPlayerSeek, 1000);
      // eslint-disable-next-line

      const eventTypes = {
        READY: 'ready', // 播放器初始化完成
        FIRST_PLAY: 'first_play', // 首次播放
        PLAYING: 'playing', // 暂停后播放
        PAUSE: 'pause', // 暂停
        SEEKING: 'seeking', // 快进快退中
        WAITING: 'waiting', // 加载中
        SEEKED: 'seeked', // 快进快退结束
        ENDED: 'ended', // 播放结束
        VOLUME_CHANGE: 'volume_change', // 音量变化
        RATE_CHANGE: 'rate_change', // 倍速变化
        TIMEUPDATE: 'timeupdate', // 播放进度更新
        LOADEDMETADATA: 'loadedmetadata', //
        QUALITY_CHANGE: 'quality_change', // 切换清晰度
        ENDED_AD: 'ended_ad', // 广告结束
        FULLSCREEN_CHANGE: 'full_screen_change', // 全屏/退出全屏
        ERROR: 'error', // 错误事件监听
      };

      // 创建百家云播放器
      this.BJYPlayer = new BPlayer({
        container: document.getElementById('player'),
        vid,
        token,
      });

      // 播放器初始化完成
      this.BJYPlayer.on(eventTypes.READY, () => {
        this.listenerToQualityChange('bjy');
        this.handleVideoQualities('bjy');
      });
      // 播放结束
      this.BJYPlayer.on(eventTypes.ENDED, () => {
        this.onPlayerEnded();
      });
      // 首次播放
      this.BJYPlayer.on(eventTypes.FIRST_PLAY, () => {
        this.onBJYPlayerPlay();
      });
      // 暂停后播放
      this.BJYPlayer.on(eventTypes.PLAYING, () => {
        this.onBJYPlayerPlay();
      });
      // 暂停
      this.BJYPlayer.on(eventTypes.PAUSE, () => {
        this.onBJYPlayerPause();
      });
      // 错误事件监听
      this.BJYPlayer.on(eventTypes.ERROR, (error) => {
        this.playerErrorMsg = JSON.stringify(error);
      });
      // 快进快退中
      this.BJYPlayer.on(eventTypes.SEEKED, () => {
        seekFn();
      });

      // this.BJYPlayer = new bjcPlayer('#player', {
      //   token,
      //   definition: 'high', // high 高清 low 低清
      //   disableDefinitionSwitch: true,
      //   useEncrypt: true,
      //   onended: () => {
      //     // 结束
      //     // console.log('结束');
      //     this.onPlayerEnded();
      //   },
      //   onplay: () => {
      //     // console.log('播放触发');
      //     this.onBJYPlayerPlay();
      //   },
      //   onpause: () => {
      //     // console.log('播放暂停触发');
      //     this.onBJYPlayerPause();
      //   },
      //   onerror: () => {
      //     // console.log(e, '播放错误触发');
      //   },
      //   onseeked: () => {
      //     seekFn();
      //   },
      // });
      // this.BJYPlayer.play(vid);
      this.loading = false;
    },
    debounce(fn, timer) {
      // 进度条防抖
      let timerOut = null;
      return (...args) => {
        if (timerOut) clearTimeout(timerOut);
        timerOut = setTimeout(() => {
          fn.apply(this, args);
        }, timer);
      };
    },

    // 点击返回至导学页
    goBack() {
      this.$router.replace({
        path: '/learningGuide',
        query: {
          catalogId: this.routeParams.openCourseId,
        },
      });
    },

    // 选中tree的当前视频节点
    async getNodeResource() {
      const params = {
        nodeId: this.routeParams.chapterId,
      };
      const res = await reqGetNodeResource(params);
      if (res.code === 0) {
        document.title = this.headerTitle;
        this.headerTitle = res.data[0].resourceName;
        document.title = this.headerTitle;
      }
    },

    // 鉴权
    async checkCourse() {
      let result = false;
      try {
        const res = await reqGetCheckCourse({
          curriculumId: this.productCurriculumId || '',
          nodeId: this.routeParams.chapterId,
          resourceId: this.routeParams.resourceId,
          resourceType: 3,
        });
        if (res.code === 0 && res.data === true) {
          result = true;
        } else {
          this.$toast('您暂无权限观看此视频～');
        }
      } catch (e) {
        // console.log('鉴权失败');
      }
      return result;
    },

    // 获取课程目录信息
    async getCourseTreeInfo() {
      try {
        const result = await reqCourseDetail({
          id: this.routeParams.openCourseId,
        });
        if (result.code === 0) {
          const {
            productCurriculumId, skuId, productId, lastLearningChapterId, productName, productCategoryName, productSkuBaseInfoRespVO: { price }
          } = result.data;
          this.learnData = result.data;
          Object.assign(this, {
            productCurriculumId,
            skuId,
            productId,
            lastLearningChapterId,
            productName,
          });
          const { courseNodes } = await reqCourseTree(productCurriculumId);
          this.treeData = courseNodes;
          this.productName = productName;
          this.productCategoryName = productCategoryName;
          this.price = price;
          this.findNowTreeList(this.treeData);
          this.getLearningProgress(this.routeParams.openCourseId);
        } else {
          this.canPlay = false;
        }
      } catch (e) {
        this.loading = false;
        if (String(e).indexOf('Network Error') > -1) {
          this.$toast('无可用网络，请检查您的网络');
        } else {
          this.$toast('获取课程详情失败');
        }
      }
    },
    // 获取学习进度
    async getLearningProgress(id) {
      const res = await reqNewLearnProgress(id);
      if (res.code === 0) {
        this.learningProgressList = res.data;
      }
    },

    // 找到当前节点视频的兄弟列表，做下一节播放
    // eslint-disable-next-line consistent-return
    findNowTreeList(nodes = [], parentNode = {}) {
      // eslint-disable-next-line no-restricted-syntax
      for (const item of nodes) {
        if (item.id === Number(this.routeParams.chapterId)) {
          this.videoList = nodes;
          this.$set(item, 'activityPlay', true);
          // eslint-disable-next-line no-param-reassign
          parentNode.expand = true; // 展开树
          return;
        }
        if (item.children) {
          this.findNowTreeList(item.children, item);
        }
      }
    },

    // 获取视频上次学习进度
    getLearnDuration() {
      const { chapterId, openCourseId: userProductId } = this.$route.params;
      reqNewLearnProgress(userProductId).then((res) => {
        if (res) {
          const lastLearnDuration = res?.data?.find(
            (item) => Number(item.chapterId) === Number(chapterId),
          )?.position;
          this.lastLearnDuration = lastLearnDuration;
        }
      });
    },

    // 上报进度计时器，300秒上报一次
    setTimer() {
      window.clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.reportCount += 1;
        if (this.reportCount >= 300) {
          this.reportPlayerTime(0);
        }
      }, 1000);
    },

    // 重新播放
    replay() {
      if (this.playerType === 'CC') {
        this.player.play();
        this.player.jumpToTime(0);
      } else {
        this.videoEndTool = false;
        this.BJYPlayer.resume();
      }
    },

    // 播放下一节
    nextVideo() {
      const { id, resourceList } = this.nextVideoInfo;
      const { resourceSource = 1 } = resourceList[0];
      this.$router.replace({
        name: 'record',
        params: {
          chapterId: id,
          resourceId: resourceList[0].resourceId,
          openCourseId: this.routeParams.openCourseId,
          vid: resourceList[0].vid,
          type: resourceSource, // 1 CC 2 百家云
          duration: resourceList[0].duration,
        },
      });
    },

    // 录播播放结束时回调
    onPlayerEnded() {
      window.clearInterval(this.timer);
      this.reportPlayerTime(3); // 结束上报
      const nowVideoIndex = this.videoList.findIndex(
        (item) => item.id === Number(this.routeParams.chapterId),
      );
      if (
        nowVideoIndex < this.videoList.length - 1 &&
        this.videoList[nowVideoIndex + 1].studyResourceType === 3
      ) {
        this.nextVideoInfo = this.videoList[nowVideoIndex + 1];
      } else {
        this.nextVideoInfo = {};
      }
      this.videoEndTool = true;
    },

    // 录播播放暂停
    onPlayerPause() {
      window.clearInterval(this.timer);
      // 当前播放位置大于等于视频长度时，不进行播放暂停上报，进行播放结束上报
      const currentTime = this.player.getPosition();
      const videoTotalTime = this.player.getDuration();
      if (currentTime < videoTotalTime) {
        this.reportPlayerTime(2);
      }
    },

    // 录播播放时回调
    onPlayerPlay() {
      this.videoEndTool = false;
      this.reportCount = 0;
      if (!this.isFirstEnter) {
        this.setTimer(); // 开始计时上报
        return;
      }
      //  初始化后需上报一次
      const firstReportClock = setInterval(() => {
        try {
          if (this.player.getDuration && this.player.getDuration()) {
            clearInterval(firstReportClock);
            const videoTotalTime = this.player.getDuration();
            if (
              this.lastLearnDuration < videoTotalTime &&
              Math.floor(videoTotalTime) !== this.lastLearnDuration
            ) {
              // eslint-disable-next-line no-unused-expressions
              this.lastLearnDuration && this.player.jumpToTime(this.lastLearnDuration);
            }
            this.reportPlayerTime(1, true, this.lastLearnDuration);
            this.isFirstEnter = false;
            this.setTimer(); // 开始计时上报
          }
        } catch (error) {
          // err
        }
      }, 200);
    },
    // 百家云录播播放时回调
    onBJYPlayerPlay() {
      this.videoEndTool = false;
      this.reportCount = 0;
      if (!this.isFirstEnter) {
        this.setTimer(); // 开始计时上报
        return;
      }
      //  初始化后需上报一次
      const firstReportClock = setInterval(() => {
        try {
          // 如果上次播放的时间 小于总时长 就跳转到上次播放的地方
          if (this.BJYDuration) {
            clearInterval(firstReportClock);
            if (this.lastLearnDuration < this.BJYDuration) {
              this.BJYPlayer.seek(this.lastLearnDuration);
            }
            this.reportPlayerTime(1, true, this.lastLearnDuration);
            this.isFirstEnter = false;
            this.setTimer(); // 开始计时上报
          }
        } catch (error) {
          // err
        }
      }, 200);
    },
    // 百家云播放暂停时回调
    onBJYPlayerPause() {
      window.clearInterval(this.timer);
      // 当前播放位置大于等于视频长度时，不进行播放暂停上报，进行播放结束上报
      const BJYCurrentTime = this.BJYPlayer.currentTime;
      if (BJYCurrentTime < this.BJYDuration) {
        this.reportPlayerTime(2);
      }
    },

    // 录播拖拽
    onPlayerSeek() {
      this.reportPlayerTime(4);
    },
    uploadPageWxpose() {
      if (flag && startViewTime) return;
      flag = true;
      const endViewTime = moment().unix();
      const diff = endViewTime - startViewTime;
      startViewTime = 0;
      const { productId, productName, productCategoryName, price } = this;
      const nowVideoIndex = this.videoList.findIndex((item) => item.id === Number(this.routeParams.chapterId));
      const { isAllowAudition } = this.videoList[nowVideoIndex].resourceList[0];
      if (price !== null && price !== undefined) {
        gio('track', 'videoDetailexit_event', {
          courseId_var: productId.toString(),
          courseName_var: productName,
          courseSubject_var: productCategoryName,
          coursePrice_var: price.toString(),
          isLogin_var: 'true',
          platform_var: gioPlatform(),
          browsingDuration_var: `${diff >= 600 ? 600 : diff}`,
          isAudition_var: isAllowAudition ? '是' : '否',
        });
      }

    },

    // 录播
    setPlayerCallBack() {
      if (window.createCCH5Player) {
        this.createPlayer();
      } else {
        window.onCCH5PlayerLoaded = this.onCCH5PlayerLoaded;
      }
      flag = false;
      startViewTime = moment().unix();
      // window.onCCH5PlayerLoaded = this.createPlayer;
      window.on_CCH5player_ended = this.onPlayerEnded;
      window.on_CCH5player_play = this.onPlayerPlay;
      window.on_CCH5player_pause = this.onPlayerPause;
      window.on_CCH5player_ready = this.onPlayerReady;
      window.on_player_seek = this.onPlayerSeek;
      window.on_h5player_error = this.onPlayerError;
      window.on_switch_quality = this.onSwitchQuality;
      // window.get_cc_verification_code = this.get_cc_verification_code;
    },
    // 切换清晰度回调
    onSwitchQuality(vid, newQuality) {
      // localStorage.setItem('qualityMsg', JSON.stringify({ type: 'cc', newQuality })); // 设置切换标识
    },
    // cc播放器错误回调
    onPlayerError(info) {
      this.playerErrorMsg = info
        ? JSON.stringify(info, (key, value) => (typeof value === 'undefined' ? '' : value))
        : '';
    },
    onPlayerReady() {
      this.loading = false;
      this.player.play();
      this.listenerToQualityChange('cc'); // 监听用户切换视频清晰度
      this.handleVideoQualities('cc');
    },

    // 录播初始化
    onCCH5PlayerLoaded() {
      window.ccH5PlayerJsLoaded = true;
      this.createPlayer();
    },

    createPlayer() {
      // 如果没有userid 刷新页面
      if (!this.userInfo.id) {
        window.location.reload();
        return;
      }
      this.playerEle = document.getElementById('player');
      const createCCH5PlayerParams = {
        vid: this.routeParams.vid,
        siteid: RECORD_SITE_ID,
        autoStart: true,
        playtype: 1, // H5播放器
        width: '100%',
        height: '100%',
        open_barrage: false,
        useX5Play: true,
        parentNode: this.playerEle,
        realAutoPlay: true,
        closeHistoryTime: 1,
        isShare: false, // TODO：隐藏分享按钮，目前现在不生效，用CSS强制隐藏了
        vc: `${this.userInfo.id}:${this.routeParams.openCourseId}`,
      };
      this.player = window.createCCH5Player(createCCH5PlayerParams);
    },
    // 上报当前学习进度
    // 上报类型
    reportPlayerTime(isDrag = 0, isFirst = false, lastLearnProgress) {
      const { chapterId, openCourseId, type, duration } = this.routeParams;
      const isCC = Number(type) === 1; // CC，否则是百家云
      // 获取当前位置时间
      let currentTime;
      //  获取视频总时长
      let videoTotalTime;

      if (isCC && this.player) {
        // CC
        currentTime = isFirst ? 0 : this.player.getPosition();
        videoTotalTime = duration || this.player.getDuration();
      }
      // 百家云
      if (this.BJYPlayer) {
        currentTime = isFirst ? 0 : this.BJYPlayer.currentTime;
        videoTotalTime = this.BJYDuration;
      }
      if (isFirst && lastLearnProgress && lastLearnProgress < videoTotalTime) {
        currentTime = lastLearnProgress;
      }
      if ((isFirst || currentTime) && videoTotalTime) {
        if (currentTime - videoTotalTime > 0) currentTime = videoTotalTime;
        const { id } = this.userInfo;
        const postData = {
          userId: id,
          productId: this.productId,
          productSkuId: this.skuId,
          userProductId: openCourseId,
          curriculumId: this.productCurriculumId,
          chapterId,
          chapterName: this.headerTitle,
          sourceType: 3, // 录播
          position: Math.ceil(currentTime),
          learnProgress: (Math.ceil(currentTime) / Math.ceil(videoTotalTime)).toFixed(2),
          reportTime: this.reportCount,
          isDrag,
          source: judgmentPlatform() === 'HarmonyOS' ? 8 : 5, // 5:h5 8:鸿蒙
          ua: window.navigator.userAgent,
          updateTime: this.$root.getLocalTime(),
        };

        this.reportCount = 0;
        sendUploadStudyProgress(postData)
          .then(() => {
            console.log('上报成功～record');
          })
          .catch(() => {
            console.log('上报参数出错了');
          });
      }
    },

    // 销毁播放器
    destroyPlay() {
      window.clearInterval(this.timer);
      this.timer = null;
      document.getElementById('player').innerHTML = '';
      if (this.player) {
        window.ccH5PlayerJsLoaded = false;
        this.player.destroy();
        this.player = null;
      }
      if (this.BJYPlayer) {
        this.BJYPlayer.destroy();
        this.BJYPlayer = null;
      }
    },

    /* gio埋点 */
    async gioReName() {
      const nowVideoIndex = this.videoList.findIndex(
        (item) => item.id === Number(this.routeParams.chapterId),
      );

      const { resourceName, vid, isAllowAudition } = this.videoList[nowVideoIndex].resourceList[0];
      let { data } = await reqClassNameType(this.productId);
      gio('track', 'listenCourse_event', {
        videoID_var: vid,
        videoName_var: resourceName,
        videoType_var: '录播',
        isAudition_var: isAllowAudition ? '是' : '否',
        courseId_var: this.productId.toString(),
        courseName_var: this.productName,
        classSize_var: data.className,
        platform_var: gioPlatform(),
        enter_var: '导学页',
      });
    },
    evaluateClose() {
      this.evaluateVisible = false;
    },
  },
  async beforeRouteLeave(to, from, next) {
    try {
      if (this.player && this.player.getVideoState() === 'play' && this.isCC) {
        this.reportPlayerTime(2);
      } else if (Number(this.routeParams.type) === 2) {
        this.reportPlayerTime(2);
      }
      // eslint-disable-next-line
      // $.DW && $.DW.destroy && $.DW.destroy();
      this.destroyPlay();
    } catch {
      // err
    }
    next();
  },
};
</script>
<style scoped lang="scss">
.video-record-page {
  .feedback-icon {
    position: absolute;
    top: 30px;
    right: 32px;
    width: 43px;
    height: 43px;
  }
  .evaluate-icon {
    position: absolute;
    top: 30px;
    right: 82px;
    width: 43px;
    height: 43px;
  }
}

.empty {
  width: 100%;
  height: 100px;
}

.video-record {
  position: relative;

  #player,
  #playbackPlayer {
    display: flex;
    align-items: center;
    height: calc(100vw * (9 / 16));
    background: black;
  }

  .jurisdiction {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: #fff;
    font-size: 26px;
  }

  .next-video {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: white;
    background: rgba(0, 0, 0, 0.5);

    .video-title {
      padding: 0 20%;
    }

    span {
      margin-bottom: 20px;
      font-size: 26px;
    }

    .tool-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 22px;

      div {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .replay-btn {
        width: 150px;
        height: 50px;
        color: #ff6c02;
        font-size: 26px;
        border: 2px solid #ff6c02;
        border-radius: 23px;
      }

      div:last-child {
        width: 150px;
        height: 50px;
        color: white;
        font-size: 26px;
        background: #ff6c02;
        border: 2px solid #ff6c02;
        border-radius: 23px;
      }

      .next-btn {
        margin-left: 24px;
      }
    }
  }
}

.course-tree {
  .tree-title {
    height: 73px;
    padding: 27px 36px 10px;
    color: #787878;
    font-size: 25px;
    line-height: 36px;
    background: white;
  }

  .tree-div {
    max-height: calc(100vh - 100vw * (9 / 16) - 100px - 73px - 100px);
    overflow-y: scroll;
  }
}
</style>

<style lang="scss">
.video-record {
  .adrPlayBtn {
    display: none !important;
  }
}

#track {
  width: 50% !important;
}

.bplayer-fullscreen.h5-full-screen {
  z-index: 1009 !important;
}
</style>
